'use strict';
/**
* Restituisce il valore del query param globale (non inerente alla navigazione client-side)
* @param name nome del parametro
* @param caseInsensitive cerca il parametro nella forma case-insensitive (default: false)
*/

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = queryParamGetter;
function queryParamGetter(name, caseInsensitive) {
  caseInsensitive = !!caseInsensitive;

  name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');

  var regexModifiers = '';
  if (caseInsensitive) {
    regexModifiers = regexModifiers + 'i';
  }
  var regex = new RegExp('[\\?&]' + name + '=([^&#]*)', regexModifiers),
      results = regex.exec(location.search);
  return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
}


//////////////////
// WEBPACK FOOTER
// ./~/infocert-utils/distribution/utils.services/queryparam.getter.js
// module id = 20
// module chunks = 2